import React, { useState } from 'react';
import ReportedDisabledList from './components/ReportedDisabledList';
import ActionBar from '../layout/ActionBar';
import UploadDisabled from './slideout/UploadDisabled';
import SlidingPane from 'react-sliding-pane';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';
import { useAppSelector } from '../../hooks';

function ReportedDisabled() {
  usePageTitle(['Disabled', 'Keys']);
  const disabledTransactions = useAppSelector(
    (state) => state.disabledTransactions
  );
  const { t } = useTranslation();
  const [reload, setReload] = useState<any>();
  const [uploadKeysSlideoutOpen, setUploadKeysSlideoutOpen] = useState(false);
  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={() => setUploadKeysSlideoutOpen(true)}
          text={t('Upload disabled keys')}
        />
      </ActionBar>
      <ReportedDisabledList
        reload={reload}
        disabledTransactions={disabledTransactions}
      />
      <SlidingPane
        isOpen={uploadKeysSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => {
          setUploadKeysSlideoutOpen(false);
          setReload(new Date());
        }}
      >
        <UploadDisabled
          done={() => {
            setUploadKeysSlideoutOpen(false);
            setReload(new Date());
          }}
          cancel={() => setUploadKeysSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default ReportedDisabled;
